import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form-mui';

export const FormInitializer = ({ initialValues }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    if (initialValues) {
      for (const key in initialValues) {
        if (Object.prototype.hasOwnProperty.call(initialValues, key)) {
          const val = initialValues[key];

          setValue(key, val);
        }
      }
    }
  }, [initialValues, setValue]);

  return null;
};
